import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import {
  getFileFormatByKey,
  getRegionValueByKey,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/summarySettingAtom';
import { pipe } from '@intelligence/components/DownloadCommon/DownloadPage/utils';
// import { PC_CONSOLE_GAME_SEGMENT } from '../common/baseConfig';
const getSummarySheet = (params: Record<string, any>) => {
  const list: any[] = [];
  const { region_method, file_format } = params || {};
  const setSummarySheet = pipe(getRegionValueByKey(region_method), getFileFormatByKey(file_format));
  setSummarySheet(list);
  return list;
};
export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    downloadFetchApi: '',
    summarySheet: getSummarySheet(params),
  };
};
